import type { ListBuilderList } from '../../../types';
import {
	duplicateAccountColumn,
	duplicateGroupColumn,
	duplicateLicenseColumn,
	reviewedGroupActionColumn,
	reviewNoteColumn,
	reviewOutcomeColumn,
	shipToColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';
import { COMPLIANCE_ATTENTION_LIST_IDS } from '../list-ids';
import { DUPLICATE_GROUP_SORT_OPTIONS } from './duplicate-group-sort';

/**
 * Duplicate License — REVIEWED (PD-16653). The groups a decision is hiding
 * from the Duplicate License list: "Being fixed" (back after 14 days, soonest
 * first) and "Fine as is" (until the group's copies change). Each row shows
 * the decision, its note, and who made it when; Open shows the group review,
 * where the decision can be reopened.
 *
 * COUNT PARITY. The locked `licenseDuplicateLicense: reviewed` resolves to
 * the members of the groups the Duplicate License card nets out, so the two
 * lists partition the card's groups.
 */
export const duplicateLicenseReviewedList: ListBuilderList = {
	id: COMPLIANCE_ATTENTION_LIST_IDS.duplicateLicenseReviewed,
	cacheTTL: 300000,
	name: 'Duplicate Reviewed',
	type: 'default',
	active: true,
	sortOrder: 13,
	filterRules: {
		...hideOtherCardFilters(['licenseDuplicateLicense']),
		licenseDuplicateLicense: {
			defaultValue: [
				{ id: 'reviewed', label: 'Reviewed: Fine as is or Being fixed' },
			],
			locked: true,
		},
	},
	columns: [
		duplicateGroupColumn,
		duplicateAccountColumn,
		shipToColumn,
		duplicateLicenseColumn,
		reviewOutcomeColumn,
		reviewNoteColumn,
		reviewedGroupActionColumn,
	],
	sortOptions: DUPLICATE_GROUP_SORT_OPTIONS,
	defaultSortId: 'group-risk',
};
